import styled, { createGlobalStyle, css } from 'styled-components'
import { Page } from '../PrintView/style'

export const GlobalStyle = createGlobalStyle`
    body {
        background-color: white !important;
    }
    @media print {
        @page {
            ${props =>
                props.orientation &&
                css`
                    size: ${props.orientation};
                `}
            /* size: ${props => props.orientation}; */
            /* size: 210mm 297mm; */
            
            margin: 0;
            margin-top: 1cm;
        }
    }
`

export const LabelPage = styled(Page)`
    height: auto;
    max-height: none;

    margin: auto;
    padding: 0 4mm;

    /* display: flex;
    flex-direction: row;
    flex-wrap: wrap;  */

    /* display: grid;
    grid-template-rows: repeat(1fr, 40mm);
    grid-template-columns: repeat(2, 100mm); */

    display: block;
    column-count: 2; 
    column-width: 100mm; 
    column-gap: 0mm;
`

export const ProductLabelContent = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
`

export const ProductLabel = styled.div`
    height: ${props => props.small ? '30mm' : '39mm'};
    position: relative;
    
    @media print {
        page-break-before: ${props => props.breakPage ? 'always' : 'avoid'};
        page-break-inside: avoid;
        /* margin-top: ${props => props.addMarginTop ? '1cm' : '0'}; */
    }

    border-right: 0.255px dashed ${props => props.theme.header_background};
    border-left: 0.25px dashed ${props => props.theme.header_background};

    header {
        text-align: left;
        display: flex;
        background-color: ${props => props.theme.header_background};
        width: 100%;
        height: 15mm;
        img {
            height: 20mm;
        }

        h1 {
            margin: 0;
            padding-top: 1mm;
            min-height: 15mm;
            font-size: 15pt;
            font-weight: 600;
            color: ${props => props.theme.header_font_color};
        }
    }

    footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 2mm;

        display: flex;
        align-items: flex-end;
    }
`